module.exports = __webpack_public_path__ + "static/media/smb2.79da3122.webp";